module.exports = __webpack_public_path__ + "img/Support.c0c2ad39.png";